import { fetchForms } from './fetch-forms';
import { fetchAddressForms } from '../../services/fetch-address-forms';
import { hasMultilineAddress } from '../../services/has-multiline-address';
import { INITIAL_DATA_LOADERS } from '@wix/form-fields/controller';
import { defaultLocaleDatasetLoader, } from '../../services/load-translations';
import { toError } from '../common/error';
export const getLocaleDataset = async ({ allForms, locale, localeDatasetLoader, errorMonitor, }) => {
    const updatedLocaleDatasetLoader = localeDatasetLoader ??
        defaultLocaleDatasetLoader(allForms, locale, errorMonitor);
    return updatedLocaleDatasetLoader();
};
export const getAddressTemplates = async ({ forms, existingAddressTemplates, httpClient, errorHandler, excludeEcomAddress = false, }) => {
    const hasMultilineAddressInForms = forms.some((f) => hasMultilineAddress(f, { excludeEcomAddress }));
    if (hasMultilineAddressInForms && !existingAddressTemplates) {
        return fetchAddressForms(httpClient, errorHandler);
    }
    return existingAddressTemplates;
};
export const getFieldInitialData = async ({ forms, httpClient, errorHandler, wixCodeApi, environment, bi, }) => {
    const loaders = Object.entries(INITIAL_DATA_LOADERS).filter(([fieldType]) => forms.some((form) => form.fields?.some((field) => fieldType === field.view?.fieldType)));
    return Promise.all(loaders.map(async ([fieldType, loader]) => {
        const form = forms.find((f) => f.fields?.some((field) => field.view?.fieldType === fieldType));
        const result = await loader(httpClient, errorHandler, wixCodeApi, form?.id, form, environment, bi);
        return [fieldType, result];
    })).then((results) => results.reduce((acc, [fieldType, result]) => {
        acc[fieldType] = result;
        return acc;
    }, {}));
};
export const loadAdditionalForms = async ({ namespace, formIds, additionalMetadata, formKind, httpClient, errorMonitor, errorHandler, locale, }) => {
    try {
        if (!formIds || formIds.length === 0) {
            return null;
        }
        const newFormsById = await fetchForms({
            formIds,
            formKind,
            namespace,
            httpClient,
            errorMonitor,
            throwWhenFormMissing: false,
            additionalMetadata,
            errorHandler,
            locale,
        });
        const newForms = Object.values(newFormsById).filter(Boolean);
        if (newForms.length === 0) {
            return null;
        }
        return newFormsById;
    }
    catch (error) {
        console.error('Error loading additional forms:', error);
        errorMonitor.captureException(toError(error));
        return null;
    }
};
//# sourceMappingURL=load-forms.js.map